var recaptchaChecked = false;
var baseChildren = null;
var baseCar = null;
var carBrands = [];

window.recaptchaCallback = function() {
    recaptchaChecked = true;
};

window.expiredRecaptchaCallback = function()
{
    recaptchaChecked = false;
    grecaptcha.reset();
};

var validInputs = {
    email : false
};

$(function () {
    if(window.location.hash === '#first') {
        $('#welcome-message').show();
        $('html,body').animate({ scrollTop: $("#welcome-message").offset().top - 50 }, 'slow');
    }

    saveBaseChildren();
    saveBaseCar();
    customValidators();
    masks();
    validationRules();
    getCarBrands();

    var cpfInput = $('.children').find(".mask-cpf");
    var dateInput = $('.children').find(".mask-date");
    var yearInput = $('.car').find(".mask-year");

    cpfInput.mask("000.000.000-00");
    cpfInput.rules("add", "cpfBR");

    dateInput.mask("00/00/0000");
    dateInput.rules("add", "dateITA");

    yearInput.mask("0000");
    yearInput.rules("add", "validYear");
});

$(document).on('click', '.remove-children', function(){
    var r = confirm("Tem certeza que deseja remover?");

    if (r === true) {
        $('#children-' + $(this).data('index')).remove();
    }
});

$(document).on('click', '.remove-car', function(){
    var r = confirm("Tem certeza que deseja remover?");

    if (r === true) {
        $('#car-' + $(this).data('index')).remove();
    }
});

$(document).on('change', '.car-brand', function(){
    $('.loader').show();

    var elem = $(this);
    var parent = elem.parents('.car');
    var modelSibling = parent.find('.car-model');

    var get = $.ajax({
        type: "GET",
        url: '/search/car-models/' + $(this).val(),
        contentType: false,
        processData: false,
        dataType: "json"
    });

    get.done(function (data) {
        modelSibling.select2({
            data: data
        });

        if(!elem.data('loaded')){
            modelSibling.select2('open');
        }

        modelSibling.on('select2:select', function(){
           parent.find('.mask-year').focus();
        });
    }).always(function(){
        $('.loader').hide();
    });
});

$(document).on('change', '.mask-cpf', function(){
    var elem = $(this);

    if(elem.val() && elem.valid() && elem.data('children')){
        $('.loader').show();

        var get = $.ajax({
            type: "GET",
            url: '/search/get-person/' + elem.val().replace(/\D/g, ''),
            dataType: "json"
        });

        get.done(function(data){
            if (data.cod === 200) {
                if (data.data !== false) {
                    var parent = elem.parents('.children');

                    parent.find('.mask-date').val(data.data.birthDate);
                    parent.find('.name').val(data.data.name).focus();
                    parent.find('input[type=hidden]').val(data.data.id);
                    parent.find('select').val(data.data.gender);
                }
            }
        });

        get.always(function(){
            $('.loader').hide();
        });
    }
});

$(document).on('change', '.mask-cpf, .mask-date', function(){
    var parentElem = $(this).parents('.children');
    var cpfElem = parentElem.find('.mask-cpf');
    var dateElem = parentElem.find('.mask-date');
    var nameElem = parentElem.find('.name');

    if (!nameElem.val() && (cpfElem.val() && cpfElem.valid() && cpfElem.data('children')) && (dateElem.val() && dateElem.valid()) && cpfElem.data('children')) {
        $('.loader').show();

        $.ajax({
            type: "GET",
            url: '/search/search-cpf/' + cpfElem.val().replace(/\D/g, '') + '/' + dateElem.val().replace(/\/+/g, '-'),
            cache: false,
            dataType: "json",
            success: function success(data) {
                if (data.cod === 200) {
                    nameElem.val(data.data.name);
                }
            },
            complete: function (){
                $('.loader').hide();
                nameElem.focus();
            }
        });
    }
});

$(document).on('change', '.children-input', function(){
    var parent = $(this).parents('.children');

    parent.find('.mask-date').attr('required', true);
    parent.find('.name').attr('required', true);
    parent.find('select').attr('required', true);
});

$(document).on('change', '.car-input', function(){
    var parent = $(this).parents('.car');

    parent.find('input').attr('required', true);
});

function populateForm(data) {
    if (!data) return;

    $("input[name='personName']").val(data.name);
    $("input[name='rg']").val(data.otherDocument);
    $("select[name='gender']").val(data.gender);
    $("select[name='maritalStatus']").val(data.maritalStatus);

    if (data.birthDate) {
        $("input[name='birthDate']").val(data.birthDate);
    }

    if (data.addresses.length > 0) {
        var address = data.addresses[0];

        $("input[name='streetName']").val(address.address);
        $("input[name='cep']").val(address.zipCode);
        $("input[name='neighborhood']").val(address.neighborhood);
        $("input[name='number']").val(address.number);
        $("input[name='city']").val(address.city);
        $("input[name='complement']").val(address.complement);
        $("select[name='state']").val(address.state);
    }

    if (data.phones.length > 0) {
        var isDefault = data.phones.filter(function (element) {
            return element.isDefault === true;
        });

        $("input[name='cellPhone']").val(isDefault[0].phoneNumber);
    }

    if (data.emails.length > 0) {
        var email = '';

        for(var i in data.emails) {
            if(data.emails[i].isDefault) {
                email = data.emails[i].email;
            }
        }

        $("input[name='email']").val(email);
    }
}

function masks() {
    var phoneMask = function phoneMask(phone, e, currentField, options) {
        if (phone.length < 14) {
            return '(00) 0000-00009';
        }
        return '(00) 00000-0009';
    };

    $(".mask-phone-cell").mask(phoneMask, {
        onKeyPress: function onKeyPress(phone, e, currentField, options) {
            $(currentField).mask(phoneMask(phone), options);
        }
    });

    $('.mask-phone-fix').mask('(00) 0000-0000');
    $(".mask-number").mask("0#");
    $(".mask-cpf").mask("000.000.000-00");
    $(".mask-cnpj").mask("00.000.000/0000-00");
    $(".mask-date").mask("00/00/0000");
    $(".mask-cep").mask("00.000-000");
    $(".mask-year").mask("0000");
    $(".mask-car-plate").mask("AAA-0000");
}

function validationRules() {

    $.validator.addMethod('validYear', function(value) {
        return value <= new Date().getFullYear();
    }, 'O ano deve ser inferior ao atual');

    $('.mask-cpf').rules("add", "cpfBR");
    $('.mask-date').rules("add", "dateITA");
    $(".valid-age").rules("add", "age");
    $(".mask-year").rules("add", "validYear");
}

$('input[name=cpf],input[name=birthDate]').change(function () {
    var documentNumber = $('input[name=cpf]');
    var birthDate = $('input[name=birthDate]');

    if ((documentNumber.val() && documentNumber.valid()) && (birthDate.val() && birthDate.valid())) {
        $('.loader').show();

        $.ajax({
            type: "GET",
            url: '/search/search-cpf/' + documentNumber.val().replace(/\D/g, '') + '/' + birthDate.val().replace(/\/+/g, '-'),
            cache: false,
            dataType: "json",
            success: function success(data) {
                if (data.cod === 200) {
                    $("input[name='personName']").val(data.data.name).trigger('change');
                    $('input[name=rg]').focus();
                }else{
                    $("input[name='personName']").focus();
                }
            },
            complete: function (){
                $('.loader').hide();
            }
        });
    }
});

$("#cep").change(function () {
    $('.loader').show();

    var cep = $(this).val().replace(/\./g, "").replace(/\-/g, "");

    var get = $.ajax({
        type: "GET",
        url: '/search/cep/' + cep,
        contentType: false,
        processData: false,
        dataType: "json"
    });

    get.done(function (data) {
        if (data.cod !== 200) return;

        var address = data.data;

        $("input[name='streetName']").val(address.streetName);
        $("input[name='neighborhood']").val(address.neighborhood);
        $("input[name='city']").val(address.city);
        $("select[name='state']").val(address.state);

        if(address.streetName) {
            $("input[name='number']").focus();
        }else{
            $("input[name='streetName']").focus();
        }
    }).fail(function(jqXHR) {
        if(jqXHR.status === 403) {
            return window.showNotAllowedStateMsg();
        }
    }).always(function(){
        $('.loader').hide();
    });
});

$("#newUser").submit(function(e) {
    if(!recaptchaChecked || !$(this).valid() || !validInputs.email) {
        e.preventDefault();
    }else{
        $('.loader').show();
    }
});

$("#loginUserForm, #editUser").submit(function(e) {
    if(!$(this).valid()) {
        e.preventDefault();
    }else{
        $('.loader').show();
    }
});

$('input[name=cpf]').change(function(){
    var documentNumber = $(this).val();

    if(documentNumber && $(this).valid()) {
        $('.loader').show();

        var get = $.ajax({
            type: "GET",
            url: '/search/get-person/' + documentNumber.replace(/\D/g, ''),
            dataType: "json"
        });

        get.done(function(data){
            if (data.cod === 200) {
                if (data.message !== "") {
                    $('').appendTo('#message-save-user');
                    $('<p class="message">' + data.message + '</p>').appendTo('#message-save-user');
                    $('#message-save-user').show();

                    $('#newUser').remove();
                } else if (data.data !== false) {
                    populateForm(data.data);
                }
            }
        });

        get.always(function(){
            $('.loader').hide();
        });
    }
});

$('input[name=email]').change(function () {
    var emailElem = $(this);

    removeError(emailElem);

    if($(this).valid()) {
        $('.loader').show();

        $.ajax({
            type: "POST",
            url: '/search/email-exists',
            data: {"email": emailElem.val(), "cpf": $("#cpf").val()},
            dataType: "json",
            success: function (data) {
                validInputs.email = !data.data;

                if(!validInputs.email){
                    appendError(emailElem,'Email já cadastrado');
                }

                $('.loader').hide();
            },
            error: function (jqXHR, exception) {
                appendError(emailElem,'Email já cadastrado');
                $('.loader').hide();
            }
        });
    }
});

$('#hobbies').select2({placeholder:'Clique para selecionar os hobbies'});
$('#sports').select2({placeholder:'Clique para selecionar os esportes'});
$('#fav-stores').select2({placeholder:'Clique para selecionar suas lojas favoritas'});

$('#add-children').click(function(){
    var count = $('.children').length;
    var body = baseChildren.clone();
    body.attr('id','children-' + count);
    body.children('.remove-children').data('index',count);

    body.find('input').each(function(a, b){
        var newName = $(this).attr('name').replace('0',count);

        $(this).attr('name', newName).val('');
    });

    var select = body.find('select');
    select.attr('name',select.attr('name').replace('0',count)).val('');

    $(body[0]).appendTo('#childrens-list');

    var cpfInput = body.find(".mask-cpf");
    var dateInput = body.find(".mask-date");

    cpfInput.mask("000.000.000-00");
    cpfInput.rules("add", "cpfBR");

    dateInput.mask("00/00/0000");
    dateInput.rules("add", "dateITA");
});

$('#add-car').click(function(){
    var count = $('.car').length;
    var body = baseCar.clone();
    body.attr('id','car-' + count);
    body.children('.remove-car').data('index',count);

    body.find('input').each(function(a, b){
        var newName = $(this).attr('name').replace('0',count);

        $(this).attr('name', newName).val('');
    });

    $(body[0]).appendTo('#cars-list');

    var brandInput = body.find(".car-brand");
    var modelInput = body.find(".car-model");
    var yearInput = body.find(".mask-year");
    var plateInput = body.find(".mask-car-plate");

    yearInput.mask("0000");
    plateInput.mask("AAA-0000");

    brandInput.select2({
        data: carBrands
    });

    modelInput.select2({
        placeholder: 'Selecione a marca'
    });
});

function saveBaseChildren()
{
    baseChildren = $('.children').clone();
}

function saveBaseCar()
{
    baseCar = $('.car').clone();
}

function appendError(elem, message)
{
    if(!elem.hasClass('error-custom')) {
        var error = '<label class="error-custom">' + message + '</label>';

        elem.parent('.form-group').append(error);
        elem.addClass('error-custom');
    }
}

function removeError(elem)
{
    if(elem.hasClass('error-custom')) {
        elem.siblings('label.error-custom').remove();

        elem.removeClass('error-custom');
    }
}

function customValidators()
{
    $.validator.addMethod('age', function (value) {
        value = value.split('/');
        value = value[2] + '-' + value[1] + '-' + value[0];

        var birthDate = new Date(value);
        var age = ~~((Date.now() - birthDate) / (31557600000));

        return age >= 18;
    }, 'Precisa-se ter mais de 18 anos');

    $.validator.addMethod( "dateITA", function( value, element ) {
        var check = false,
            re = /^\d{1,2}\/\d{1,2}\/\d{4}$/,
            adata, gg, mm, aaaa, xdata;
        if ( re.test( value ) ) {
            adata = value.split( "/" );
            gg = parseInt( adata[ 0 ], 10 );
            mm = parseInt( adata[ 1 ], 10 );
            aaaa = parseInt( adata[ 2 ], 10 );
            xdata = new Date( Date.UTC( aaaa, mm - 1, gg, 12, 0, 0, 0 ) );
            if ( ( xdata.getUTCFullYear() === aaaa ) && ( xdata.getUTCMonth() === mm - 1 ) && ( xdata.getUTCDate() === gg ) ) {
                check = true;
            } else {
                check = false;
            }
        } else {
            check = false;
        }
        return this.optional( element ) || check;
    }, 'Data Inválida' );
}

function getCarBrands()
{
    $('.loader').show();

    var get = $.ajax({
        type: "GET",
        url: '/search/car-brands',
        contentType: false,
        processData: false,
        dataType: "json"
    });

    get.done(function (data) {
        carBrands = data;

        $(".car-brand").select2({
            data: data
        });

        $('.car-model').select2({
            placeholder: 'Selecione a marca'
        });
    }).always(function(){
        $('.loader').hide();
    });

    if($('.car-brand').val()){
        $('.car-brand').data('loaded', true).trigger('change');
    }
}